import React from 'react';
import { Layers, PenTool, Figma, Code, Users, BarChart } from 'lucide-react';
export const Skills = () => {
  const skills = [{
    icon: <Layers className="text-white" size={24} data-id="element-166" />,
    title: 'User Experience (UX) Design',
    description: 'Creating intuitive, accessible, and user-friendly digital experiences based on research and testing.'
  }, {
    icon: <PenTool className="text-white" size={24} data-id="element-167" />,
    title: 'User Interface (UI) Design',
    description: 'Crafting visually appealing interfaces with attention to typography, color theory, and visual hierarchy.'
  }, {
    icon: <Figma className="text-white" size={24} data-id="element-168" />,
    title: 'Prototyping',
    description: 'Building interactive prototypes that effectively communicate design concepts and functionality.'
  }, {
    icon: <Code className="text-white" size={24} data-id="element-169" />,
    title: 'Front-end Development',
    description: 'Working knowledge of HTML, CSS, and JavaScript to better collaborate with development teams.'
  }, {
    icon: <Users className="text-white" size={24} data-id="element-170" />,
    title: 'User Research',
    description: 'Conducting interviews, surveys, and usability tests to inform design decisions.'
  }, {
    icon: <BarChart className="text-white" size={24} data-id="element-171" />,
    title: 'Design Strategy',
    description: 'Aligning design solutions with business goals and user needs for maximum impact.'
  }];
  return <section id="skills" className="py-20 bg-gray-50" data-id="element-172">
      <div className="container mx-auto px-4 md:px-6" data-id="element-173">
        <div className="text-center mb-16" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-175">
            My Skills & Services
          </h2>
          <div className="w-20 h-1 bg-indigo-600 mx-auto mb-6" data-id="element-176"></div>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-177">
            I offer a comprehensive range of design services to help businesses
            create exceptional digital experiences for their users.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-178">
          {skills.map((skill, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-179">
              <div className="bg-indigo-600 rounded-full w-12 h-12 flex items-center justify-center mb-6" data-id="element-180">
                {skill.icon}
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-181">{skill.title}</h3>
              <p className="text-gray-600" data-id="element-182">{skill.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};